/**
 * 获取state的方法，可以作为公用的计算属性
 * @param {*} state
 */
export const showDialog = (state) => {
  return state.showDialog;
};
export const userInfo = (state) => {
  return state.userInfo;
};
export const deviceInfo = (state) => {
  return state.deviceInfo;
};
export const loading = (state) => {
  return state.loading;
};
